import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class SlaughterService {
    static getSlaughters(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`slaughters?filter=${qs}`, pageNumber));
    }
    static fetchSlaughter(oid) {
        return lastValueFrom(BaseService.get(`slaughters/${oid}`));
    }
    static saveSlaughter(dto) {
        return lastValueFrom(BaseService.save(`slaughters`, dto));
    }
    static deleteSlaughter(oid) {
        return lastValueFrom(BaseService.delete(`slaughters/${oid}`));
    }
    static searchSlaughterCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`slaughters-search-dropdown/${selfId}?search=${qs}`));
    }
    static startSlaughterWork(oid) {
        return lastValueFrom(BaseService.post(`slaughter-start-work/${oid}`, {}));
    }
    static stopSlaughterWork(oid) {
        return lastValueFrom(BaseService.post(`slaughter-stop-work/${oid}`, {}));
    }
    static assignLotNumbers(filter) {
        return lastValueFrom(BaseService.post(`slaughter-assign-lots`, filter));
    }
    static slaughterPrepare(filter) {
        return lastValueFrom(BaseService.post(`slaughter-prepare`, filter));
    }
    static searchSlaughterYearCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`slaughter-year-search-dropdown/${selfId}?search=${qs}`));
    }
    static searchPhaseCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`slaughter-phase-search-dropdown/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Slaughter Items
    // ----------------------------------------------------------------------
    static getSlaughterItems(slaughterId) {
        //return lastValueFrom(BaseService.getPaginated<ISlaughterItemDTO[]>(`slaughter-items/${slaughterId}`, pageNumber));
        return lastValueFrom(BaseService.get(`slaughter-items/${slaughterId}`));
    }
    static saveSlaughterItem(dto) {
        //return lastValueFrom(BaseService.save<ISlaughterItem>(`slaughter-items`, dto));
        return lastValueFrom(BaseService.post(`slaughter-items`, dto));
    }
    static deleteSlaughterItem(oid) {
        return lastValueFrom(BaseService.delete(`slaughter-items/${oid}`));
    }
    static searchSlaughterItemLotCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`slaughter-items-lot-search-dropdown/${selfId}?search=${qs}`));
    }
    // ----------------------------------------------------------------------
    // Slaughter Ingress
    // ----------------------------------------------------------------------
    static getSlaughterIngressItems(filter) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.get(`slaughter-ingress?filter=${qs}`));
    }
    static saveSlaughterIngressItemWork(dto) {
        return lastValueFrom(BaseService.post(`slaughter-ingress-work`, dto));
    }
    static saveSlaughterIngressItemSkip(dto) {
        return lastValueFrom(BaseService.post(`slaughter-ingress-skip`, dto));
    }
}
